import type { WtsGtmWindow } from '@/webtrekk'
import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router'
import { isDa } from '@/utils/CommonUtils'

const wtsGtmWindow = window as unknown as WtsGtmWindow
if (!wtsGtmWindow?.dataLayer) wtsGtmWindow.dataLayer = []

let globalLastGTMContent: string = ''

const thankYouPageExtensions = [
  isDa() ? 'digitale-schadenkarte-anfordern' : 'digitale-versicherungskarte-anfordern',
  'adresse-aendern',
  'name-aendern',
  'bankdaten-aendern'
]

function removeIDsFromURL(input: string): string {
  return (
    input
      .split('/')
      // remove segments with 123 or 123-123
      .filter((segment) => !/^(\d+|\d+-\d+)$/.test(segment))
      .join('/')
  )
}

function findKeywordInFullpath(words: string[], content: string): string | null {
  for (const word of words) {
    if (content.includes(word)) {
      return word
    }
  }
  return null
}

export const updateTrackingInformation = (
  currentRoute: RouteLocationNormalizedLoadedGeneric
): void => {
  let webtrekkContentId =
    currentRoute.path.charAt(0) === '/' ? currentRoute.path.substr(1) : currentRoute.path

  const thankYouKeyword = findKeywordInFullpath(
    thankYouPageExtensions,
    currentRoute.fullPath
  )

  if (thankYouKeyword) {
    webtrekkContentId += `?${thankYouKeyword}`
  }

  if (webtrekkContentId != globalLastGTMContent) {
    // push into GTM dataLayer
    wtsGtmWindow.dataLayer.push({
      contentId: removeIDsFromURL(webtrekkContentId),
      event: 'virtualPageView'
    })
    globalLastGTMContent = webtrekkContentId
  }
  // simply logging enabled (window.name keeps alive as long as browser window)
  if (wtsGtmWindow.name === 'enableLog') {
    console.log('track contentId (GTM): ', webtrekkContentId)
    console.log('track dataLayer (GTM): ', wtsGtmWindow.dataLayer)
    console.log('track contentGroups (WTS): ', wtsGtmWindow._ti.contentGroup)
    console.log('track contentId (WTS): ', wtsGtmWindow._ti.contentId)
  }
}
